import type { AuthConfigNanoId, ConnectedAccountNanoId, OrgNanoId, ProjectNanoId, TriggerInstanceNanoId } from "@composio/types";
// This file is auto-generated by @hey-api/openapi-ts

/**
 * Deprecated toolkit ID
 */
export type DeprecatedToolkitInfo = {
    toolkitId: string;
};

export type Error = {
    error: {
        message: string;
        code: number;
        status: number;
        request_id?: string;
        suggested_fix?: string;
        errors?: Array<(string)>;
    };
};

export type InviteTeamMemberBody = {
    email: string;
    name: string;
    role: string;
    verify_host?: string;
};

export type Tool = {
    /**
     * Unique identifier for the tool
     */
    slug: string;
    /**
     * Human-readable display name of the tool
     */
    name: string;
    /**
     * Detailed explanation of the tool's functionality and purpose
     */
    description: string;
    toolkit: {
        /**
         * Unique identifier of the parent toolkit
         */
        slug: string;
        /**
         * Human-readable name of the parent toolkit
         */
        name: string;
        /**
         * URL to the toolkit logo image
         */
        logo: string;
    };
    /**
     * Schema definition of required input parameters for the tool
     */
    input_parameters: {
        [key: string]: unknown;
    };
    /**
     * Indicates if the tool can be used without authentication
     */
    no_auth: boolean;
    /**
     * List of all available versions for this tool
     */
    available_versions: Array<(string)>;
    /**
     * Current version of the tool
     */
    version: string;
    /**
     * Schema definition of return values from the tool
     */
    output_parameters: {
        [key: string]: unknown;
    };
    /**
     * List of scopes associated with the tool
     */
    scopes: Array<(string)>;
    /**
     * List of tags associated with the tool for categorization and filtering
     */
    tags: Array<(string)>;
    deprecated: {
        /**
         * The display name of the tool
         */
        displayName: string;
        /**
         * Current version identifier of the tool
         */
        version: string;
        /**
         * List of all available versions for this tool
         */
        available_versions: Array<(string)>;
        /**
         * Indicates if this tool is deprecated and may be removed in the future
         */
        is_deprecated: boolean;
        toolkit: {
            /**
             * URL to the toolkit logo image
             */
            logo: string;
        };
    };
};

export type ToolsPaginated = {
    items: Array<Tool>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
};

export type UpdateTeamMemberBody = {
    name: string;
    email: string;
    role: string;
};

export type GetAuthByProviderNameCallbackData = {
    /**
     * Alternative authorization code format
     */
    authCode?: string;
    /**
     * Authorization code from OAuth provider
     */
    code?: string;
    /**
     * Error code from OAuth provider
     */
    error?: string;
    /**
     * Error description from OAuth provider
     */
    errorDescription?: string;
    /**
     * OAuth provider name
     */
    providerName: 'github' | 'google';
    /**
     * State parameter for CSRF protection
     */
    state?: string;
};

export type GetAuthByProviderNameCallbackResponse = ({
    /**
     * Human-readable result message of the authentication operation
     */
    message: string;
    /**
     * Data payload containing authentication credentials and user information
     */
    data: {
        /**
         * JWT to be used for subsequent authenticated requests
         */
        jwtToken: string;
        /**
         * Basic information about the authenticated user
         */
        userData: {
            /**
             * Email address of the authenticated user
             */
            email: string;
        };
    };
} | void);

export type GetAuthByProviderNameLoginData = {
    /**
     * Name of the OAuth provider to use for authentication (e.g., "google", "github")
     */
    providerName: string;
    /**
     * Custom redirect URI after authentication
     */
    redirectUri?: string;
};

export type PostAuthByProviderNameOneTapData = {
    providerName: 'github' | 'google';
    requestBody?: ({
    data: {
        jwt: string;
    };
    type: 'jwt';
} | {
    data: {
        authCode: string;
    };
    type: 'auth-code';
});
};

export type PostAuthByProviderNameOneTapResponse = ({
    clientId: (string) | null;
    apiKey: (string) | null;
    email: (string) | null;
    orgId: (string) | null;
});

export type PostAuthMagicLinkSendData = {
    requestBody?: {
        /**
         * Email address of the user requesting authentication
         */
        email: string;
        /**
         * Custom URL where the magic link should redirect for verification
         */
        verify_host?: string;
        /**
         * Flag indicating if this is for MCP authentication
         */
        is_mcp?: boolean;
    };
};

export type PostAuthMagicLinkSendResponse = ({
    /**
     * Indicates the result of the magic link email sending operation
     */
    status: string;
});

export type PostAuthMagicLinkVerifyData = {
    requestBody?: {
        /**
         * The unique one-time token sent to the user's email for authentication
         */
        token: string;
    };
};

export type PostAuthMagicLinkVerifyResponse = ({
    /**
     * Human-readable result message of the verification operation
     */
    message: string;
    /**
     * Data payload containing authentication credentials and user information
     */
    data: {
        /**
         * JWT to be used for subsequent authenticated requests
         */
        jwtToken: string;
        /**
         * Unique identifier for the user's organization
         */
        orgId: string;
        /**
         * Email address of the authenticated user
         */
        email: string;
        /**
         * Unique identifier for the user within the organization
         */
        memberId: string;
    };
});

export type GetAuthSessionInfoResponse = ({
    /**
     * Details of the current active project (null if accessing with org-level credentials)
     */
    project: {
        /**
         * Internal auto-incrementing ID for the project
         */
        auto_id: number;
        /**
         * UUID identifier for the project
         */
        id: string;
        /**
         * Organization UUID that this project belongs to
         */
        org_id: string;
        /**
         * User-defined name for the project
         */
        name: string;
        /**
         * Email address used for project notifications
         */
        email: string;
        /**
         * Short, URL-friendly unique identifier for the project
         */
        nano_id: ProjectNanoId;
        /**
         * Date and time when the project was created
         */
        created_at: string;
        /**
         * Date and time when the project was last modified
         */
        updated_at: string;
        /**
         * Endpoint URL for trigger webhook notifications
         */
        webhook_url: (string) | null;
        /**
         * Endpoint URL for event webhook notifications
         */
        event_webhook_url: (string) | null;
        /**
         * Secret used to verify webhook signatures
         */
        webhook_secret: (string) | null;
        /**
         * Flag indicating if triggers are enabled for this project
         */
        triggers_enabled: boolean;
        /**
         * Date and time when the project last subscribed to updates
         */
        last_subscribed_at: (string) | null;
        /**
         * Flag indicating if the project has been deleted
         */
        deleted: boolean;
        /**
         * Flag indicating if the project uses the new webhook format
         */
        is_new_webhook: boolean;
        /**
         * Organization details including members
         */
        org: {
            /**
             * Short, URL-friendly unique identifier for the organization
             */
            id: OrgNanoId;
            /**
             * User-defined name for the organization
             */
            name: string;
            /**
             * Current subscription plan level
             */
            plan: string;
            /**
             * Array of members belonging to this organization
             */
            org_members: Array<{
                /**
                 * Internal auto-incrementing ID for the organization member
                 */
                auto_id: number;
                /**
                 * UUID identifier for the organization member
                 */
                id: string;
                /**
                 * Organization UUID that this member belongs to
                 */
                org_id: string;
                /**
                 * Email address of the organization member
                 */
                email: string;
                /**
                 * User-defined name for the organization member
                 */
                name: string;
                /**
                 * Access role of the member within the organization
                 */
                role: string;
                /**
                 * Optional custom metadata for the organization member
                 */
                metadata?: unknown;
                /**
                 * Date and time when the member was added to the organization
                 */
                created_at: string;
                /**
                 * Date and time when the member was last modified
                 */
                updated_at: string;
                /**
                 * Date and time when the member was removed from the organization (if applicable)
                 */
                deleted_at: (string) | null;
            }>;
        };
    } | null;
    /**
     * Details of the API key used for authentication (null if using session auth)
     */
    api_key: {
        /**
         * Internal auto-incrementing ID for the API key
         */
        auto_id: number;
        /**
         * UUID identifier for the API key
         */
        id: string;
        /**
         * User-defined name for the API key
         */
        name: string;
        /**
         * Short, URL-friendly unique identifier for the associated project
         */
        project_id: ProjectNanoId;
        /**
         * UUID identifier for the organization member who owns this API key
         */
        org_member_id: string;
        /**
         * Date and time when the API key was created
         */
        created_at: string;
        /**
         * Date and time when the API key was last modified
         */
        updated_at: string;
        /**
         * Date and time when the API key was deleted (if applicable)
         */
        deleted_at: (string) | null;
        /**
         * The actual API key value (usually only shown once during creation)
         */
        key: string;
        /**
         * Flag indicating if the API key has been deleted
         */
        deleted: boolean;
    } | null;
    /**
     * Information about the authenticated user
     */
    org_member: {
        /**
         * UUID identifier for the organization member
         */
        id: string;
        /**
         * Email address of the authenticated user
         */
        email: string;
        /**
         * Display name of the authenticated user
         */
        name: string;
        /**
         * Access role of the authenticated user within the organization
         */
        role: string;
    };
});

export type PostAuthSessionLogoutResponse = ({
    /**
     * Human-readable result message of the logout operation
     */
    message: string;
});

export type PostAdminIdentifyData = {
    /**
     * Hash information used to identify the user
     */
    requestBody: {
        /**
         * Secure hash derived from the user email that allows identifying them without exposing the email directly
         */
        hash: string;
    };
};

export type PostAdminIdentifyResponse = ({
    /**
     * Project ID that can be used with other API endpoints
     */
    clientId: string;
    /**
     * Secret API key that should be securely stored and used for API authentication
     */
    apiKey: string;
    /**
     * Email address of the user who owns this client/project
     */
    email: string;
    /**
     * Organization ID that this project is associated with
     */
    orgId: string;
});

export type GetAdminConnectionsData = {
    /**
     * The unique identifier slug of the toolkit to filter connections by
     */
    toolkitSlug?: string;
    /**
     * Optional client auto ID to filter connections for custom apps by project
     */
    xClientAutoId?: string;
    /**
     * Admin authentication token required for administrative operations
     */
    xComposioAdminToken: string;
};

export type GetAdminConnectionsResponse = ({
    /**
     * Collection of account connection objects, may be empty if no connections exist
     */
    items: Array<{
        /**
         * Identifier that can be used with other API endpoints that operate on connections
         */
        id: string;
    }>;
});

export type PostAdminAuthRefreshData = {
    /**
     * Connection IDs to process and parallelism configuration
     */
    requestBody: {
        /**
         * List of connection identifiers that need token refresh
         */
        connectionIds: Array<(string)>;
        /**
         * Controls processing speed and system load. Higher values process faster but increase load.
         */
        parallelism?: number;
    };
    /**
     * Admin authentication token required for administrative operations
     */
    xComposioAdminToken: string;
};

export type PostAdminAuthRefreshResponse = ({
    /**
     * List of connections where token refresh was successful or not needed
     */
    success: Array<(string)>;
    /**
     * Array of connections that failed to refresh with detailed error information
     */
    failures: Array<{
        /**
         * Connection ID that failed during refresh
         */
        connectionId: string;
        /**
         * Specific error code identifying why the refresh operation failed
         */
        error: string;
    }>;
});

export type PostAuthConfigsData = {
    requestBody?: {
        toolkit: {
            /**
             * Toolkit slug to create auth config for
             */
            slug: string;
        };
        auth_config?: ({
    type: 'use_composio_managed_auth';
    /**
     * The name of the integration
     */
    name?: string;
    credentials?: {
        [key: string]: (string | boolean | number);
    };
    tool_access_config?: {
        /**
         * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
         */
        tools_for_connected_account_creation?: Array<(string)>;
    };
    /**
     * Use tool_access_config instead. This field will be deprecated in the future.
     * @deprecated
     */
    restrict_to_following_tools?: Array<(string)>;
} | {
    type: 'use_custom_auth';
    /**
     * The name of the integration
     */
    name?: string;
    authScheme: 'OAUTH2' | 'OAUTH1' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH';
    credentials: {
        [key: string]: (string | boolean | number);
    };
    proxy_config?: {
        /**
         * The url of the auth proxy
         */
        proxy_url: string;
        /**
         * The auth key for the auth proxy
         */
        proxy_auth_key?: string;
    };
    /**
     * Use tool_access_config instead. This field will be deprecated in the future.
     * @deprecated
     */
    restrict_to_following_tools?: Array<(string)>;
    tool_access_config?: {
        /**
         * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
         */
        tools_for_connected_account_creation?: Array<(string)>;
    };
});
    };
};

export type PostAuthConfigsResponse = ({
    toolkit: {
        /**
         * The unique key of the toolkit
         */
        slug: string;
    };
    auth_config: {
        /**
         * The auth config id of the toolkit (must be a valid auth config id)
         */
        id: AuthConfigNanoId;
        /**
         * The authentication mode of the toolkit
         */
        auth_scheme: string;
        /**
         * Whether the auth config is managed by Composio
         */
        is_composio_managed: boolean;
        /**
         * The tools that the user can use with the auth config
         */
        restrict_to_following_tools?: Array<(string)>;
    };
});

export type GetAuthConfigsData = {
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * The app id to filter by
     */
    deprecatedAppId?: string;
    deprecatedStatus?: string;
    /**
     * Whether to filter by composio managed auth configs
     */
    isComposioManaged?: (string | boolean);
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Search auth configs by name
     */
    search?: string;
    /**
     * Show disabled auth configs
     */
    showDisabled?: (boolean) | null;
    /**
     * Comma-separated list of toolkit slugs to filter auth configs by
     */
    toolkitSlug?: string;
};

export type GetAuthConfigsResponse = ({
    items: Array<{
        /**
         * The unique ID of the authentication configuration
         */
        id: AuthConfigNanoId;
        /**
         * The UUID of the authentication configuration (for backward compatibility)
         */
        uuid: string;
        /**
         * The type of the authentication configuration (custom or default)
         */
        type: 'default' | 'custom';
        /**
         * Information about the associated integration
         */
        toolkit: {
            /**
             * The unique identifier of the integration app
             */
            slug: string;
            /**
             * The URL to the integration app's logo image
             */
            logo: string;
        };
        /**
         * The display name of the authentication configuration
         */
        name: string;
        /**
         * The authentication scheme used (e.g., OAuth2, API Key, etc.)
         */
        auth_scheme?: 'OAUTH2' | 'OAUTH1' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH';
        /**
         * Whether this authentication configuration is managed by Composio or the user
         */
        is_composio_managed?: boolean;
        /**
         * The authentication credentials (tokens, keys, etc.) - may be partially hidden for security
         */
        credentials?: {
            [key: string]: unknown;
        };
        /**
         * Current status of the authentication configuration
         */
        status: 'ENABLED' | 'DISABLED';
        /**
         * The identifier of the user who created the auth config
         */
        created_by?: string;
        /**
         * ISO 8601 date-time when the auth config was created
         */
        created_at?: string;
        /**
         * ISO 8601 date-time when the auth config was last updated
         */
        last_updated_at?: string;
        /**
         * The number of active connections using this auth config
         */
        no_of_connections: number;
        /**
         * Fields expected during connection initialization
         */
        expected_input_fields?: Array<unknown>;
        /**
         * Use tool_access_config instead. This field will be deprecated in the future.
         * @deprecated
         */
        restrict_to_following_tools?: Array<(string)>;
        tool_access_config: {
            /**
             * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
             */
            tools_for_connected_account_creation?: Array<(string)>;
            /**
             * The actions that the user can perform on the auth config. If passed, this will update the actions that the user can perform on the auth config.
             */
            tools_available_for_execution?: Array<(string)>;
        };
        /**
         * Deprecated parameters maintained for backward compatibility
         */
        deprecated_params: {
            /**
             * Deprecated: Default connector ID
             */
            default_connector_id: (string) | null;
            /**
             * Deprecated: Member UUID
             */
            member_uuid?: string;
            /**
             * Deprecated: Toolkit ID
             */
            toolkit_id?: string;
            /**
             * Deprecated: Fields expected during connection initialization
             */
            expected_input_fields?: Array<{
                [key: string]: unknown;
            }>;
        };
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type GetAuthConfigsByNanoidData = {
    /**
     * The unique identifier of the authentication configuration to retrieve
     */
    nanoid: AuthConfigNanoId;
};

export type GetAuthConfigsByNanoidResponse = ({
    /**
     * The unique ID of the authentication configuration
     */
    id: AuthConfigNanoId;
    /**
     * The UUID of the authentication configuration (for backward compatibility)
     */
    uuid: string;
    /**
     * The type of the authentication configuration (custom or default)
     */
    type: 'default' | 'custom';
    /**
     * Information about the associated integration
     */
    toolkit: {
        /**
         * The unique identifier of the integration app
         */
        slug: string;
        /**
         * The URL to the integration app's logo image
         */
        logo: string;
    };
    /**
     * The display name of the authentication configuration
     */
    name: string;
    /**
     * The authentication scheme used (e.g., OAuth2, API Key, etc.)
     */
    auth_scheme?: 'OAUTH2' | 'OAUTH1' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH';
    /**
     * Whether this authentication configuration is managed by Composio or the user
     */
    is_composio_managed?: boolean;
    /**
     * The authentication credentials (tokens, keys, etc.) - may be partially hidden for security
     */
    credentials?: {
        [key: string]: unknown;
    };
    /**
     * Current status of the authentication configuration
     */
    status: 'ENABLED' | 'DISABLED';
    /**
     * The identifier of the user who created the auth config
     */
    created_by?: string;
    /**
     * ISO 8601 date-time when the auth config was created
     */
    created_at?: string;
    /**
     * ISO 8601 date-time when the auth config was last updated
     */
    last_updated_at?: string;
    /**
     * The number of active connections using this auth config
     */
    no_of_connections: number;
    /**
     * Fields expected during connection initialization
     */
    expected_input_fields?: Array<unknown>;
    /**
     * Use tool_access_config instead. This field will be deprecated in the future.
     * @deprecated
     */
    restrict_to_following_tools?: Array<(string)>;
    tool_access_config: {
        /**
         * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
         */
        tools_for_connected_account_creation?: Array<(string)>;
        /**
         * The actions that the user can perform on the auth config. If passed, this will update the actions that the user can perform on the auth config.
         */
        tools_available_for_execution?: Array<(string)>;
    };
    /**
     * Deprecated parameters maintained for backward compatibility
     */
    deprecated_params: {
        /**
         * Deprecated: Default connector ID
         */
        default_connector_id: (string) | null;
        /**
         * Deprecated: Member UUID
         */
        member_uuid?: string;
        /**
         * Deprecated: Toolkit ID
         */
        toolkit_id?: string;
        /**
         * Deprecated: Fields expected during connection initialization
         */
        expected_input_fields?: Array<{
            [key: string]: unknown;
        }>;
    };
});

export type PatchAuthConfigsByNanoidData = {
    /**
     * The unique identifier of the authentication configuration to update
     */
    nanoid: AuthConfigNanoId;
    requestBody?: ({
    type: 'custom';
    credentials: {
        [key: string]: unknown;
    };
    /**
     * Use tool_access_config instead. This field will be deprecated in the future.
     * @deprecated
     */
    restrict_to_following_tools?: Array<(string)>;
    tool_access_config?: {
        /**
         * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
         */
        tools_for_connected_account_creation?: Array<(string)>;
        /**
         * The actions that the user can perform on the auth config. If passed, this will update the actions that the user can perform on the auth config.
         */
        tools_available_for_execution?: Array<(string)>;
    };
} | {
    type: 'default';
    scopes?: string;
    /**
     * Use tool_access_config instead. This field will be deprecated in the future.
     * @deprecated
     */
    restrict_to_following_tools?: Array<(string)>;
    tool_access_config?: {
        /**
         * Tools used to generate the minimum required scopes for the auth config (only valid for OAuth). If passed, this will update the scopes.
         */
        tools_for_connected_account_creation?: Array<(string)>;
        /**
         * The actions that the user can perform on the auth config. If passed, this will update the actions that the user can perform on the auth config.
         */
        tools_available_for_execution?: Array<(string)>;
    };
});
};

export type PatchAuthConfigsByNanoidResponse = ({
    [key: string]: unknown;
});

export type DeleteAuthConfigsByNanoidData = {
    /**
     * The unique identifier of the authentication configuration to delete
     */
    nanoid: AuthConfigNanoId;
};

export type DeleteAuthConfigsByNanoidResponse = ({
    [key: string]: unknown;
});

export type PatchAuthConfigsByNanoidByStatusData = {
    /**
     * The unique identifier of the authentication configuration to update
     */
    nanoid: AuthConfigNanoId;
    /**
     * The new status to set for the auth configuration
     */
    status: 'ENABLED' | 'DISABLED';
};

export type PatchAuthConfigsByNanoidByStatusResponse = ({
    [key: string]: unknown;
});

export type PostCliCreateSessionResponse = ({
    /**
     * Unique identifier for the CLI session. UUID v4 format used for tracking and retrieval.
     */
    id: string;
    /**
     * The 6-character hexadecimal code used for CLI login
     */
    code: string;
    /**
     * The ISO timestamp when the session expires
     */
    expiresAt: string;
    /**
     * The current status of the session
     */
    status: 'pending' | 'linked';
});

export type GetCliGetSessionData = {
    /**
     * CLI session ID (UUID format) or 6-character code to check. Both formats are supported for flexibility in client implementations.
     */
    id: string;
};

export type GetCliGetSessionResponse = ({
    /**
     * The unique identifier for the CLI session
     */
    id: string;
    /**
     * The 6-character hexadecimal code used for CLI login
     */
    code: string;
    /**
     * The current status of the session
     */
    status: 'pending' | 'linked';
    /**
     * The ISO timestamp when the session expires
     */
    expiresAt: string;
    /**
     * Information about the linked account, if any. Null if the session status is "pending".
     */
    account: {
        /**
         * The ID of the linked account
         */
        id: string;
        /**
         * The email address of the linked account
         */
        email: string;
        /**
         * The display name of the linked account
         */
        name: string;
    } | null;
});

export type PutCliLinkSessionData = {
    /**
     * The session ID or code to link to the current user
     */
    requestBody?: {
        /**
         * The CLI session ID or code to link to the current user
         */
        id: string;
    };
};

export type PutCliLinkSessionResponse = ({
    /**
     * The unique identifier for the CLI session
     */
    id: string;
    /**
     * The 6-character hexadecimal code used for CLI login
     */
    code: string;
    /**
     * The current status of the session
     */
    status: 'pending' | 'linked';
    /**
     * The ISO timestamp when the session expires
     */
    expiresAt: string;
    /**
     * Information about the linked account. Always present for successful responses from this endpoint.
     */
    account: {
        /**
         * The ID of the linked account
         */
        id: string;
        /**
         * The email address of the linked account
         */
        email: string;
        /**
         * The display name of the linked account
         */
        name: string;
    };
});

export type GetConnectedAccountsData = {
    /**
     * The auth config ids of the connected accounts
     */
    authConfigIds?: Array<(string)> | null;
    /**
     * The cursor to paginate through the connected accounts
     */
    cursor?: (string) | null;
    /**
     * The labels of the connected accounts
     */
    labels?: Array<(string)> | null;
    /**
     * The limit of the connected accounts to return
     */
    limit?: (number) | null;
    /**
     * The order by of the connected accounts
     */
    orderBy?: 'created_at' | 'updated_at';
    /**
     * The status of the connected account
     */
    statuses?: Array<('INITIALIZING' | 'INITIATED' | 'ACTIVE' | 'FAILED' | 'EXPIRED' | 'INACTIVE')> | null;
    /**
     * The toolkit slugs of the connected accounts
     */
    toolkitSlugs?: Array<(string)> | null;
    /**
     * The user ids of the connected accounts
     */
    userIds?: Array<(string)> | null;
};

export type GetConnectedAccountsResponse = ({
    items: Array<{
        toolkit: {
            /**
             * The slug of the toolkit
             */
            slug: string;
        };
        auth_config: {
            /**
             * The id of the auth config
             */
            id: AuthConfigNanoId;
            /**
             * the authScheme is part of the connection state use it there
             * @deprecated
             */
            auth_scheme: 'OAUTH2' | 'OAUTH1' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH';
            /**
             * Whether the auth config is managed by Composio
             */
            is_composio_managed: boolean;
            /**
             * Whether the auth config is disabled
             */
            is_disabled: boolean;
            deprecated?: {
                /**
                 * The uuid of the auth config
                 */
                uuid: string;
            };
        };
        /**
         * The id of the connection
         */
        id: ConnectedAccountNanoId;
        /**
         * This is deprecated, we will not be providing userId from this api anymore, you will only be able to read via userId not get it back
         * @deprecated
         */
        user_id: string;
        /**
         * The status of the connection
         */
        status: 'INITIALIZING' | 'INITIATED' | 'ACTIVE' | 'FAILED' | 'EXPIRED' | 'INACTIVE';
        /**
         * The created at of the connection
         */
        created_at: string;
        /**
         * The updated at of the connection
         */
        updated_at: string;
        /**
         * The state of the connection
         */
        state: ({
    authScheme: 'OAUTH1';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    oauth_token: string;
    authUri: string;
    oauth_token_secret: string;
    redirectUrl: string;
    callbackUrl?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'OAUTH2';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    code_verifier?: string;
    redirectUrl: string;
    callback_url?: string;
    finalRedirectUri?: string;
    webhook_signature?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    expired_at?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
});
} | {
    authScheme: 'COMPOSIO_LINK';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'API_KEY';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BEARER_TOKEN';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'GOOGLE_SERVICE_ACCOUNT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'NO_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'CALCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BILLCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC_WITH_JWT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    username: string;
    password: string;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    username: string;
    password: string;
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
});
        /**
         * This is deprecated, use `state` instead
         * @deprecated
         */
        data: {
            [key: string]: unknown;
        };
        /**
         * The reason the connection is disabled
         */
        status_reason: (string) | null;
        /**
         * Whether the connection is disabled
         */
        is_disabled: boolean;
        /**
         * The endpoint to make test request for verification
         */
        test_request_endpoint?: string;
        deprecated?: {
            /**
             * The labels of the connection
             */
            labels: Array<(string)>;
            /**
             * The uuid of the connection
             */
            uuid: string;
        };
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type PostConnectedAccountsData = {
    requestBody?: {
        auth_config: {
            /**
             * The auth config id of the app (must be a valid auth config id)
             */
            id: AuthConfigNanoId;
        };
        connection: {
            /**
             * The state of the connected account
             */
            state?: ({
    authScheme: 'OAUTH1';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    oauth_token: string;
    authUri: string;
    oauth_token_secret: string;
    redirectUrl: string;
    callbackUrl?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'OAUTH2';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    code_verifier?: string;
    redirectUrl: string;
    callback_url?: string;
    finalRedirectUri?: string;
    webhook_signature?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    expired_at?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
});
} | {
    authScheme: 'COMPOSIO_LINK';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'API_KEY';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BEARER_TOKEN';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'GOOGLE_SERVICE_ACCOUNT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'NO_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'CALCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BILLCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC_WITH_JWT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    username: string;
    password: string;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    username: string;
    password: string;
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
});
            /**
             * DEPRECATED: This parameter will be removed in a future version. Please use state instead.
             * @deprecated
             */
            data?: {
                [key: string]: unknown;
            };
            /**
             * The user id of the connected account
             */
            user_id?: string;
            /**
             * The URL to redirect to after connection completion
             */
            callback_url?: string;
            /**
             * DEPRECATED: This parameter will be removed in a future version. Please use callback_url instead.
             * @deprecated
             */
            redirect_uri?: string;
            /**
             * DEPRECATED: This parameter will be removed in a future version.
             * @deprecated
             */
            deprecated_is_v1_rerouted?: boolean;
        };
    };
};

export type PostConnectedAccountsResponse = ({
    /**
     * The id of the connected account
     */
    id: ConnectedAccountNanoId;
    /**
     * The connection data of the connected account
     */
    connectionData: ({
    authScheme: 'OAUTH1';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    oauth_token: string;
    authUri: string;
    oauth_token_secret: string;
    redirectUrl: string;
    callbackUrl?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'OAUTH2';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    code_verifier?: string;
    redirectUrl: string;
    callback_url?: string;
    finalRedirectUri?: string;
    webhook_signature?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    expired_at?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
});
} | {
    authScheme: 'COMPOSIO_LINK';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'API_KEY';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BEARER_TOKEN';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'GOOGLE_SERVICE_ACCOUNT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'NO_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'CALCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BILLCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC_WITH_JWT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    username: string;
    password: string;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    username: string;
    password: string;
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
});
    /**
     * DEPRECATED: This field will be removed in a future version
     * @deprecated
     */
    status: 'INITIALIZING' | 'INITIATED' | 'ACTIVE' | 'FAILED' | 'EXPIRED' | 'INACTIVE';
    /**
     * DEPRECATED: This field will be removed in a future version
     * @deprecated
     */
    redirect_url: (string) | null;
    /**
     * DEPRECATED: This field will be removed in a future version
     * @deprecated
     */
    redirect_uri: (string) | null;
    deprecated: {
        /**
         * The uuid of the connected account
         */
        uuid: string;
        /**
         * The uuid of the auth config
         */
        authConfigUuid: string;
    };
});

export type GetConnectedAccountsByNanoidData = {
    /**
     * The unique identifier (nanoid) of the connected account
     */
    nanoid: ConnectedAccountNanoId;
};

export type GetConnectedAccountsByNanoidResponse = ({
    toolkit: {
        /**
         * The slug of the toolkit
         */
        slug: string;
    };
    auth_config: {
        /**
         * The id of the auth config
         */
        id: AuthConfigNanoId;
        /**
         * the authScheme is part of the connection state use it there
         * @deprecated
         */
        auth_scheme: 'OAUTH2' | 'OAUTH1' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH';
        /**
         * Whether the auth config is managed by Composio
         */
        is_composio_managed: boolean;
        /**
         * Whether the auth config is disabled
         */
        is_disabled: boolean;
        deprecated?: {
            /**
             * The uuid of the auth config
             */
            uuid: string;
        };
    };
    /**
     * The id of the connection
     */
    id: ConnectedAccountNanoId;
    /**
     * This is deprecated, we will not be providing userId from this api anymore, you will only be able to read via userId not get it back
     * @deprecated
     */
    user_id: string;
    /**
     * The status of the connection
     */
    status: 'INITIALIZING' | 'INITIATED' | 'ACTIVE' | 'FAILED' | 'EXPIRED' | 'INACTIVE';
    /**
     * The created at of the connection
     */
    created_at: string;
    /**
     * The updated at of the connection
     */
    updated_at: string;
    /**
     * The state of the connection
     */
    state: ({
    authScheme: 'OAUTH1';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    oauth_token: string;
    authUri: string;
    oauth_token_secret: string;
    redirectUrl: string;
    callbackUrl?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    oauth_token: string;
    oauth_token_secret: string;
    oauth_verifier?: string;
    consumer_key?: string;
    redirectUrl?: string;
    callback_url?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'OAUTH2';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    code_verifier?: string;
    redirectUrl: string;
    callback_url?: string;
    finalRedirectUri?: string;
    webhook_signature?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    access_token: string;
    id_token?: string;
    token_type?: string;
    refresh_token?: (string) | null;
    expires_in?: (number | string | unknown);
    scope?: (string | Array<(string)> | unknown);
    webhook_signature?: string;
    /**
     * for slack user scopes
     */
    authed_user?: {
        access_token?: string;
        scope?: string;
    };
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    /**
     * The oauth2 state prefix for the connection
     */
    state_prefix?: string;
    /**
     * Whether to return the redirect url without shortening
     */
    long_redirect_url?: boolean;
    expired_at?: string;
    [key: string]: ((unknown | string | boolean) | null) | undefined;
});
} | {
    authScheme: 'COMPOSIO_LINK';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'API_KEY';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    generic_api_key?: string;
    api_key?: string;
    bearer_token?: string;
    basic_encoded?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BEARER_TOKEN';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    token: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'GOOGLE_SERVICE_ACCOUNT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    credentials_json: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'NO_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'CALCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BILLCOM_AUTH';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIALIZING';
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INITIATED';
    redirectUrl: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    sessionId: string;
    devKey: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
} | {
    authScheme: 'BASIC_WITH_JWT';
    val: ({
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'ACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'INACTIVE';
    username: string;
    password: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'FAILED';
    username: string;
    password: string;
    error?: string;
    error_description?: string;
    [key: string]: ((unknown | string) | null) | undefined;
} | {
    subdomain?: string;
    'your-domain'?: string;
    region?: string;
    shop?: string;
    account_url?: string;
    COMPANYDOMAIN?: string;
    extension?: string;
    form_api_base_url?: string;
    instanceEndpoint?: string;
    api_url?: string;
    borneo_dashboard_url?: string;
    proxy_username?: string;
    proxy_password?: string;
    domain?: string;
    version?: string;
    dc?: string;
    site_name?: string;
    instanceName?: string;
    account_id?: string;
    your_server?: string;
    server_location?: string;
    base_url?: string;
    status: 'EXPIRED';
    username: string;
    password: string;
    expired_at?: string;
    [key: string]: ((unknown | string) | null) | undefined;
});
});
    /**
     * This is deprecated, use `state` instead
     * @deprecated
     */
    data: {
        [key: string]: unknown;
    };
    /**
     * The reason the connection is disabled
     */
    status_reason: (string) | null;
    /**
     * Whether the connection is disabled
     */
    is_disabled: boolean;
    /**
     * The endpoint to make test request for verification
     */
    test_request_endpoint?: string;
    deprecated?: {
        /**
         * The labels of the connection
         */
        labels: Array<(string)>;
        /**
         * The uuid of the connection
         */
        uuid: string;
    };
    /**
     * The initialization data of the connection, including configuration parameters
     * @deprecated
     */
    params: {
        [key: string]: unknown;
    };
});

export type DeleteConnectedAccountsByNanoidData = {
    /**
     * The unique identifier (nanoid) of the connected account
     */
    nanoid: ConnectedAccountNanoId;
};

export type DeleteConnectedAccountsByNanoidResponse = ({
    /**
     * Indicates whether the connected account was successfully deleted
     */
    success: boolean;
});

export type PatchConnectedAccountsByNanoIdStatusData = {
    /**
     * The unique identifier of the connected account
     */
    nanoId: ConnectedAccountNanoId;
    requestBody?: {
        /**
         * Set to true to enable the account or false to disable it
         */
        enabled: boolean;
    };
};

export type PatchConnectedAccountsByNanoIdStatusResponse = ({
    /**
     * Indicates whether the connected account status was successfully updated
     */
    success: boolean;
});

export type PostConnectedAccountsByNanoidRefreshData = {
    /**
     * The unique identifier of the connected account
     */
    nanoid: ConnectedAccountNanoId;
    redirectUrl?: string;
    requestBody?: {
        redirect_url?: string;
    };
};

export type PostConnectedAccountsByNanoidRefreshResponse = ({
    /**
     * The unique identifier of the connected account
     */
    id: string;
    /**
     * The current status of the connected account (e.g., active, pending, failed)
     */
    status: 'INITIALIZING' | 'INITIATED' | 'ACTIVE' | 'FAILED' | 'EXPIRED' | 'INACTIVE';
    /**
     * The URL to which the user should be redirected to complete the authentication process (null for auth schemes that do not require redirection)
     */
    redirect_url: (string) | null;
});

export type PostInternalTriggerLogsData = {
    requestBody?: {
        /**
         * Return logs from the last N time units
         */
        time?: '5m' | '30m' | '6h' | '1d' | '1w' | '1month' | '1y';
        /**
         * Start time for logs (epoch timestamp in milliseconds)
         */
        from?: (number) | null;
        /**
         * End time for logs (epoch timestamp in milliseconds)
         */
        to?: (number) | null;
        /**
         * Filter logs by their status level
         */
        status?: 'all' | 'success' | 'error';
        /**
         * Search term to filter logs
         */
        search?: string;
        integrationId?: string;
        entityId?: string;
        /**
         * Filter logs by user ID
         */
        userId?: string;
        /**
         * The limit of trigger logs to return
         */
        limit?: (number) | null;
        cursor?: (string) | null;
        /**
         * Advanced search parameters for filtering logs
         */
        search_params?: Array<{
            field?: string;
            operation?: string;
            value?: string;
        }>;
    };
};

export type PostInternalTriggerLogsResponse = ({
    nextCursor: (string) | null;
    data?: Array<{
        id: string;
        connectionId: string;
        clientId: string;
        entityId: string;
        status: string;
        appName: string;
        createdAt: string;
        /**
         * Log entity type (trigger or action)
         */
        type: 'trigger' | 'action';
        meta: {
            id: string;
            /**
             * Log entity type (trigger or action)
             */
            type: 'trigger' | 'action';
            createdAt: string;
            updatedAt: string;
            provider: string;
            clientId: string;
            connectionId: string;
            triggerProviderPayload?: string;
            triggerClientPayload?: string;
            triggerClientError?: string;
            triggerName?: string;
            triggerClientResponse?: string;
        };
    }>;
});

export type PostInternalActionExecutionLogsData = {
    requestBody?: {
        /**
         * cursor_that_can_be_used_to_paginate_through_the_logs
         */
        cursor: (number) | null;
        /**
         * number_of_logs_to_return
         */
        limit?: number;
        /**
         * whether_the_search_is_case_sensitive_or_not
         */
        case_sensitive?: (boolean) | null;
        /**
         * start_time_of_the_logs_in_epoch_time
         */
        from?: number;
        /**
         * end_time_of_the_logs_in_epoch_time
         */
        to?: number;
        search_params?: Array<{
            field?: string;
            operation?: string;
            value?: string;
        }>;
    };
};

export type PostInternalActionExecutionLogsResponse = ({
    data: Array<{
        id: string;
        actionKey: string;
        appKey: string;
        app: {
            icon: string;
            name: string;
        };
        connectedAccountId: string;
        entityId: string;
        status: 'success' | 'failed';
        executionTime: number;
        minimalResponse: string;
        createdAt: number;
    }>;
    nextCursor: (number) | null;
});

export type GetInternalActionExecutionFieldsResponse = ({
    fields: {
        [key: string]: Array<{
            /**
             * The id of the field
             */
            id: string;
            /**
             * The display name of the field
             */
            displayName: string;
            /**
             * The type of the field
             */
            type: string;
            /**
             * The regex of the field
             */
            regex?: string;
        }>;
    };
});

export type GetInternalActionExecutionLogByIdData = {
    id: string;
};

export type GetInternalActionExecutionLogByIdResponse = ({
    actionLogId: string;
    actionId: string;
    status: 'success' | 'error' | 'warning' | 'info';
    app: {
        name: string;
        uniqueId: string;
        icon: string;
    };
    version: string;
    connection: {
        id: string;
        entity: string;
    };
    session: {
        [key: string]: unknown;
    };
    executionMetadata: {
        [key: string]: unknown;
    };
    steps: Array<{
        type: 'tool_execution' | 'fetch_connection_details';
        startTime: number;
        endTime: number;
        totalDuration: number;
        status: 'success' | 'failure' | 'error';
        message: string;
        metadata?: {
            encryption?: string;
        };
        logs?: Array<{
            type: 'network' | 'system';
            level: string;
            message: string;
            requestId: string;
            time: number;
            request: {
                method: string;
                url: string;
                headers?: {
                    [key: string]: (string);
                };
                params?: {
                    [key: string]: unknown;
                };
                timeout?: number;
                json?: {
                    [key: string]: unknown;
                };
            };
            response: {
                status: number;
                time: string;
            };
        }>;
    }>;
    payloadReceived: {
        [key: string]: unknown;
    };
    startTime: number;
    endTime: number;
    totalDuration: string;
    response: {
        [key: string]: unknown;
    };
    error: {
        [key: string]: unknown;
    };
});

export type GetOpenapiSpecsListResponse = (Array<{
    /**
     * Unique identifier for the OpenAPI specification.
     */
    id: string;
    /**
     * Descriptive name of the OpenAPI specification.
     */
    name: string;
    /**
     * ISO 8601 timestamp when the specification was created.
     */
    created_at: string;
    /**
     * ISO 8601 timestamp when the specification was last updated.
     */
    updated_at: string;
    /**
     * ISO 8601 timestamp when the specification was last synchronized with the system.
     */
    last_sync_at: string;
    /**
     * Current status of the OpenAPI specification (e.g., "processing", "ready", "failed").
     */
    status: string;
    /**
     * Detailed state information about the specification processing pipeline.
     */
    state: string;
    /**
     * Collection of log entries related to the specification processing.
     */
    logs: Array<{
        /**
         * Log message related to specification processing.
         */
        message: string;
        /**
         * Log level indicating the severity of the message (e.g., "info", "error", "warn").
         */
        level: string;
        /**
         * ISO 8601 timestamp when the log entry was created.
         */
        timestamp: string;
    }>;
    /**
     * Information about the current progress of the specification processing.
     */
    progress: {
        /**
         * Human-readable message describing the current progress or status of the specification.
         */
        message: string;
    };
}>);

export type PostOpenapiSpecsCreateData = {
    requestBody?: {
        /**
         * A descriptive name for the OpenAPI specification. This name will be used to identify the specification in the system.
         */
        name: string;
        /**
         * The full OpenAPI specification in JSON or YAML format as a string. This should be a valid OpenAPI 3.0 or 3.1 specification that describes the API endpoints.
         */
        openApiSpec: string;
        /**
         * Authentication configuration for the API in JSON format as a string. This defines how to authenticate requests to the API.
         */
        authConfig: string;
    };
};

export type PostOpenapiSpecsCreateResponse = ({
    /**
     * A unique identifier for the job that processes the OpenAPI specification. This can be used to track the status of the processing.
     */
    jobId: string;
});

export type DeleteOpenapiSpecsByIdData = {
    /**
     * The unique identifier of the OpenAPI specification to delete. This ID is returned when creating a new specification.
     */
    id: string;
};

export type DeleteOpenapiSpecsByIdResponse = ({
    [key: string]: unknown;
});

export type GetOpenapiSpecsStatusByIdData = {
    /**
     * The unique identifier of the OpenAPI specification or job ID to check status for. This ID is returned when creating a new specification.
     */
    id: string;
};

export type GetOpenapiSpecsStatusByIdResponse = ({
    [key: string]: unknown;
});

export type GetOrgApiKeyResponse = ({
    /**
     * The API key for the organization that can be used for authentication. Format: org_xxx
     */
    org_api_key: string;
});

export type PostOrgApiKeyRegenerateResponse = ({
    /**
     * The newly generated API key for the organization that can be used for authentication. Format: org_xxx
     */
    org_api_key: string;
});

export type GetOrgProjectListResponse = ({
    /**
     * Array of projects belonging to the organization
     */
    data: Array<{
        /**
         * Unique identifier for the project
         */
        id: ProjectNanoId;
        /**
         * Identifier of the organization that owns this project
         */
        org_id: OrgNanoId;
        /**
         * Name of the project
         */
        name: string;
        /**
         * Email address associated with the project
         */
        email: string;
        /**
         * ISO timestamp when the project was created
         */
        created_at: string;
        /**
         * ISO timestamp when the project was last updated
         */
        updated_at: string;
        /**
         * URL where webhook events will be sent (can be null)
         */
        webhook_url: (string) | null;
        /**
         * URL where event webhook notifications will be sent (can be null)
         */
        event_webhook_url: (string) | null;
        /**
         * Secret key used to sign webhook payloads for verification
         */
        webhook_secret: (string) | null;
        /**
         * Whether triggers are enabled for this project
         */
        triggers_enabled?: boolean;
        /**
         * ISO timestamp when the project last subscribed to updates
         */
        last_subscribed_at?: (Date) | null;
        /**
         * Indicates if the webhook configuration is using the new format
         */
        is_new_webhook?: boolean;
        /**
         * Whether this project has been soft-deleted
         */
        deleted: boolean;
    }>;
});

export type PostOrgProjectNewData = {
    requestBody?: {
        /**
         * A unique name for your project that follows the required format rules
         */
        name: string;
    };
};

export type PostOrgProjectNewResponse = ({
    /**
     * Unique identifier for the project
     */
    id: ProjectNanoId;
    /**
     * Identifier of the organization that owns this project
     */
    org_id: OrgNanoId;
    /**
     * Name of the project
     */
    name: string;
    /**
     * Email address associated with the project
     */
    email: string;
    /**
     * ISO timestamp when the project was created
     */
    created_at: string;
    /**
     * ISO timestamp when the project was last updated
     */
    updated_at: string;
    /**
     * URL where webhook events will be sent (can be null)
     */
    webhook_url: (string) | null;
    /**
     * URL where event webhook notifications will be sent (can be null)
     */
    event_webhook_url: (string) | null;
    /**
     * Secret key used to sign webhook payloads for verification
     */
    webhook_secret: (string) | null;
    /**
     * Whether triggers are enabled for this project
     */
    triggers_enabled?: boolean;
    /**
     * ISO timestamp when the project last subscribed to updates
     */
    last_subscribed_at?: (Date) | null;
    /**
     * Indicates if the webhook configuration is using the new format
     */
    is_new_webhook?: boolean;
    /**
     * Whether this project has been soft-deleted
     */
    deleted: boolean;
});

export type DeleteOrgProjectDeleteByProjectIdData = {
    /**
     * Unique identifier (Nano ID) of the project to delete
     */
    projectId: ProjectNanoId;
};

export type DeleteOrgProjectDeleteByProjectIdResponse = ({
    /**
     * Status of the delete operation
     */
    status: string;
});

export type GetOrgProjectByProjectIdData = {
    /**
     * Unique identifier (Nano ID) of the project to retrieve
     */
    projectId: ProjectNanoId;
};

export type GetOrgProjectByProjectIdResponse = ({
    /**
     * Unique identifier for the project
     */
    id: ProjectNanoId;
    /**
     * Identifier of the organization that owns this project
     */
    org_id: OrgNanoId;
    /**
     * Name of the project
     */
    name: string;
    /**
     * Email address associated with the project
     */
    email: string;
    /**
     * ISO timestamp when the project was created
     */
    created_at: string;
    /**
     * ISO timestamp when the project was last updated
     */
    updated_at: string;
    /**
     * URL where webhook events will be sent (can be null)
     */
    webhook_url: (string) | null;
    /**
     * URL where event webhook notifications will be sent (can be null)
     */
    event_webhook_url: (string) | null;
    /**
     * Secret key used to sign webhook payloads for verification
     */
    webhook_secret: (string) | null;
    /**
     * Whether triggers are enabled for this project
     */
    triggers_enabled?: boolean;
    /**
     * ISO timestamp when the project last subscribed to updates
     */
    last_subscribed_at?: (Date) | null;
    /**
     * Indicates if the webhook configuration is using the new format
     */
    is_new_webhook?: boolean;
    /**
     * Whether this project has been soft-deleted
     */
    deleted: boolean;
});

export type GetOrgProjectByProjectIdApiKeysListData = {
    /**
     * Unique identifier (Nano ID) of the project to retrieve API keys for
     */
    projectId: ProjectNanoId;
};

export type GetOrgProjectByProjectIdApiKeysListResponse = ({
    /**
     * List of all API keys for the specified project, including their properties and usage information
     */
    items: Array<{
        /**
         * Unique identifier for the API key record
         */
        id: string;
        /**
         * Descriptive name assigned to the API key for identification purposes
         */
        name: string;
        /**
         * The API key string that should be included in API requests for authentication
         */
        key: string;
        /**
         * UTC timestamp indicating when the API key was created
         */
        created_at: Date;
        /**
         * UTC timestamp indicating when the API key was last used for authentication. Will be null if the key has never been used.
         */
        last_used?: Date;
    }>;
});

export type PostOrgProjectByProjectIdApiKeysCreateData = {
    /**
     * Unique identifier (Nano ID) of the project to create an API key for
     */
    projectId: ProjectNanoId;
    requestBody?: {
        /**
         * A user-friendly name to identify the API key's purpose (e.g., "Production Server", "Test Environment")
         */
        name: string;
    };
};

export type PostOrgProjectByProjectIdApiKeysCreateResponse = ({
    /**
     * Database record identifier for the API key
     */
    id: string;
    /**
     * Descriptive name assigned to help identify the key's purpose
     */
    name: string;
    /**
     * The API key string value that should be included in API requests. This value is only shown once at creation time.
     */
    key: string;
    /**
     * UTC timestamp indicating when the API key was created. DEPRECATED: Use created_at instead.
     * @deprecated
     */
    createdAt: Date;
    /**
     * UTC timestamp indicating when the API key was created
     */
    created_at: Date;
    /**
     * UTC timestamp indicating when the API key was last used for authentication. Will be null for newly created keys.
     */
    last_used_at?: Date;
});

export type PostOrgProjectByProjectIdApiKeysCreateApiKeyData = {
    /**
     * Unique identifier (Nano ID) of the project to get or create an API key for
     */
    projectId: string;
};

export type PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse = ({
    /**
     * Database record identifier for the API key
     */
    id: string;
    /**
     * Name assigned to help identify the key's purpose. For auto-generated keys, this will be a random name.
     */
    name: string;
    /**
     * The API key string value that should be included in API requests. This value is only shown once.
     */
    key: string;
    /**
     * UTC timestamp indicating when the API key was created
     */
    created_at: Date;
    /**
     * UTC timestamp indicating when the API key was last used for authentication. Will be null for newly created keys.
     */
    last_used_at?: Date;
    /**
     * UTC timestamp indicating when the API key was created. Use created_at instead.
     * @deprecated
     */
    createdAt: Date;
    /**
     * UTC timestamp indicating when the API key was created. Use last_used_at instead.
     * @deprecated
     */
    lastUsedAt: Date;
});

export type DeleteOrgProjectByProjectIdApiKeysRemoveByIdData = {
    /**
     * Unique identifier of the API key to delete
     */
    id: string;
    /**
     * Unique identifier (Nano ID) of the project containing the API key
     */
    projectId: ProjectNanoId;
};

export type DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse = ({
    /**
     * Boolean flag indicating if the deletion operation was successful
     */
    success: boolean;
    /**
     * Status message providing details about the deletion operation
     */
    message: string;
});

export type GetOrgProjectWebhookData = {
    /**
     * Type of webhook to retrieve (trigger or event)
     */
    type: 'trigger' | 'event';
};

export type GetOrgProjectWebhookResponse = ({
    /**
     * The webhook configuration containing either trigger or event webhook URL
     */
    url: ({
    /**
     * Identifies this as a trigger webhook response
     */
    type: 'trigger';
    /**
     * The URL endpoint where trigger notifications will be delivered
     */
    webhook_url?: string;
} | {
    /**
     * Identifies this as an event webhook response
     */
    type: 'event';
    /**
     * The URL endpoint where event notifications will be delivered
     */
    event_webhook_url?: string;
});
    /**
     * The secret key that should be used to verify webhook signatures
     */
    webhook_secret: string;
    /**
     * Indicates whether the webhook was found and retrieved successfully
     */
    status: 'success' | 'not found';
});

export type DeleteOrgProjectWebhookData = {
    requestBody?: {
        /**
         * Specifies which webhook type to remove from the project configuration
         */
        type: 'trigger' | 'event';
    };
};

export type DeleteOrgProjectWebhookResponse = ({
    /**
     * Indicates the webhook URL was successfully removed
     */
    status: 'success';
});

export type PostOrgProjectWebhookUpdateData = {
    requestBody?: {
        /**
         * Specifies which webhook type to update (trigger or event)
         */
        type: 'trigger' | 'event';
        /**
         * Valid URL that will receive webhook payloads. Must include https:// protocol.
         */
        webhook_url: string;
    };
};

export type PostOrgProjectWebhookUpdateResponse = ({
    /**
     * Indicates if the webhook URL update was completed successfully
     */
    success: boolean;
    /**
     * Human-readable description of the update operation result
     */
    message: string;
});

export type PostOrgProjectWebhookRefreshResponse = ({
    /**
     * Indicates if the webhook secret was successfully refreshed
     */
    success: boolean;
    /**
     * Human-readable description of the refresh operation result
     */
    message: string;
    /**
     * The new secret key that should be used to verify incoming webhook payloads
     */
    webhook_secret: string;
});

export type GetTeamMembersListResponse = ({
    items: Array<{
        id: string;
        email: string;
        name: string;
        role: string;
        created_at: (string);
        updated_at: (string);
    }>;
});

export type PostTeamMembersInviteData = {
    requestBody?: InviteTeamMemberBody;
};

export type PostTeamMembersInviteResponse = ({
    id: string;
    email: string;
    name: string;
    role: string;
    created_at: (string);
    updated_at: (string);
});

export type DeleteTeamMembersRemoveByIdData = {
    id: string;
};

export type DeleteTeamMembersRemoveByIdResponse = ({
    success: boolean;
    message: string;
});

export type PutTeamMembersUpdateByIdData = {
    id: string;
    requestBody?: UpdateTeamMemberBody;
};

export type PutTeamMembersUpdateByIdResponse = ({
    id: string;
    email: string;
    name: string;
    role: string;
    created_at: (string);
    updated_at: (string);
});

export type GetToolkitsData = {
    /**
     * Filter toolkits by category
     */
    category?: string;
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * Whether to include local toolkits in the results
     */
    isLocal?: (boolean) | null;
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Filter toolkits by who manages them
     */
    managedBy?: 'composio' | 'all' | 'project';
    /**
     * Sort order for returned toolkits
     */
    sortBy?: 'usage' | 'alphabetically';
};

export type GetToolkitsResponse = ({
    items: Array<{
        /**
         * URL-friendly unique identifier for the toolkit
         */
        slug: string;
        /**
         * Human-readable name of the toolkit
         */
        name: string;
        /**
         * List of authentication methods supported by this toolkit
         */
        auth_schemes?: Array<(string)>;
        /**
         * List of authentication methods that Composio manages for this toolkit
         */
        composio_managed_auth_schemes?: Array<(string)>;
        /**
         * Indicates if this toolkit is specific to the current project or globally available
         */
        is_local_toolkit: boolean;
        /**
         * When true, this toolkit can be used without authentication
         */
        no_auth?: boolean;
        deprecated: DeprecatedToolkitInfo;
        /**
         * Additional metadata about the toolkit
         */
        meta: {
            /**
             * Creation date and time of the toolkit
             */
            created_at: string;
            /**
             * Last modification date and time of the toolkit
             */
            updated_at: string;
            /**
             * Human-readable description explaining the toolkit's purpose and functionality
             */
            description: string;
            /**
             * Image URL for the toolkit's branding
             */
            logo: string;
            /**
             * Link to the toolkit's main application or service website
             */
            app_url?: (string) | null;
            /**
             * List of categories associated with this toolkit
             */
            categories: Array<{
                /**
                 * Category identifier
                 */
                id: string;
                /**
                 * Human-readable category name
                 */
                name: string;
            }>;
            /**
             * Count of available triggers in this toolkit
             */
            triggers_count: number;
            /**
             * Count of available tools in this toolkit
             */
            tools_count: number;
        };
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type GetToolkitsCategoriesData = {
    /**
     * Cache control parameter
     */
    cache?: string;
};

export type GetToolkitsCategoriesResponse = ({
    items: Array<{
        /**
         * Display name of the toolkit category
         */
        name: string;
        /**
         * URL-friendly unique identifier for the category, used for filtering toolkits
         */
        id: string;
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type GetToolkitsBySlugData = {
    /**
     * Toolkit slug identifier
     */
    slug: string;
};

export type GetToolkitsBySlugResponse = ({
    /**
     * URL-friendly unique identifier for the toolkit
     */
    slug: string;
    /**
     * Human-readable name of the toolkit
     */
    name: string;
    /**
     * Indicates if this toolkit is currently enabled and available for use
     */
    enabled: boolean;
    /**
     * List of authentication methods that Composio manages for this toolkit
     */
    composio_managed_auth_schemes?: Array<(string)>;
    /**
     * Complete authentication configuration details for each supported auth method
     */
    auth_config_details?: Array<{
        /**
         * The type of authentication mode (e.g., oauth2, basic_auth, api_key)
         */
        mode: string;
        /**
         * Field groups required for different authentication stages
         */
        fields: {
            /**
             * Form fields needed when creating an authentication configuration
             */
            auth_config_creation: {
                required: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                    legacy_template_name?: string;
                }>;
                optional: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                    legacy_template_name?: string;
                }>;
            };
            /**
             * Form fields needed when connecting a user account with this authentication method
             */
            connected_account_initiation: {
                required: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                    legacy_template_name?: string;
                }>;
                optional: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                    legacy_template_name?: string;
                }>;
            };
        };
        /**
         * Configuration for proxying authentication requests to external services
         */
        proxy?: {
            /**
             * URL to which authentication requests will be proxied
             */
            base_url: string;
        };
        /**
         * Display name for this authentication method
         */
        name: string;
    }>;
    /**
     * Indicates if this toolkit is specific to the current project or globally available
     */
    is_local_toolkit: boolean;
    /**
     * If evaluation of base URL needs some connection info (like shopify), please create the connection and get the base URL from there
     */
    base_url?: string;
    /**
     * Comprehensive metadata for the toolkit including dates, descriptions, and statistics
     */
    meta: {
        /**
         * Creation date and time of the toolkit
         */
        created_at: string;
        /**
         * Last modification date and time of the toolkit
         */
        updated_at: string;
        /**
         * Human-readable description explaining the toolkit's purpose and functionality
         */
        description: string;
        /**
         * Image URL for the toolkit's branding
         */
        logo: string;
        /**
         * Link to the toolkit's main application or service website
         */
        app_url?: (string) | null;
        /**
         * List of categories associated with this toolkit
         */
        categories: Array<{
            /**
             * Human-readable category name
             */
            name: string;
            /**
             * URL-friendly identifier for the category
             */
            slug: string;
        }>;
        /**
         * Count of available triggers in this toolkit
         */
        triggers_count: number;
        /**
         * Count of available tools in this toolkit
         */
        tools_count: number;
    };
    /**
     * Endpoint to get the current user
     */
    get_current_user_endpoint?: string;
    deprecated: {
        toolkitId: string;
        getCurrentUserEndpoint?: string;
        rawProxyInfoByAuthSchemes: Array<{
            [key: string]: unknown;
        }>;
    };
});

export type GetToolsData = {
    authConfigIds?: Array<(string)> | null;
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * Filter to only show important/featured tools (set to "true" to enable)
     */
    important?: 'true' | 'false';
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Array of scopes to filter tools by)
     */
    scopes?: Array<(string)> | null;
    /**
     * Free-text search query to find tools by name, description, or functionality
     */
    search?: string;
    /**
     * Filter tools by one or more tags (can be specified multiple times)
     */
    tags?: Array<(string)>;
    /**
     * The slug of the toolkit to filter by
     */
    toolkitSlug?: string;
    /**
     * Comma-separated list of specific tool slugs to retrieve (overrides other filters)
     */
    toolSlugs?: string;
};

export type GetToolsResponse = (ToolsPaginated);

export type GetToolsEnumResponse = (string);

export type GetToolsByToolSlugData = {
    /**
     * The unique slug identifier of the tool
     */
    toolSlug: string;
};

export type GetToolsByToolSlugResponse = (Tool);

export type PostToolsExecuteByToolSlugData = {
    requestBody?: {
        /**
         * Unique identifier for the connected account to use for authentication
         */
        connected_account_id?: string;
        /**
         * Deprecated: please use user_id instead. Entity identifier for multi-entity connected accounts (e.g. multiple repositories, organizations)
         * @deprecated
         */
        entity_id?: string;
        /**
         * User id for multi-user connected accounts (e.g. multiple users, organizations)
         */
        user_id?: string;
        /**
         * Tool version to execute (defaults to "latest" if not specified)
         */
        version?: string;
        /**
         * Custom authentication parameters for tools that support parameterized authentication
         */
        custom_auth_params?: {
            /**
             * The base URL (root address) what you should use while making http requests to the connected account. For example, for gmail, it would be 'https://gmail.googleapis.com'
             */
            base_url?: string;
            parameters?: Array<{
                /**
                 * The name of the parameter. For example, 'x-api-key', 'Content-Type', etc.
                 */
                name: string;
                /**
                 * The location of the parameter. Can be 'query' or 'header'.
                 */
                in: 'query' | 'header';
                /**
                 * The value of the parameter. For example, '1234567890', 'application/json', etc.
                 */
                value: (string | number);
            }>;
            /**
             * The body to be sent to the endpoint for authentication. This is a JSON object. Note: This is very rarely needed and is only required by very few apps.
             */
            body?: {
                [key: string]: unknown;
            };
        };
        /**
         * Custom connection data for tools that support custom connection data
         */
        custom_connection_data?: ({
    authScheme: 'OAUTH2';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        /**
         * The oauth2 state prefix for the connection
         */
        state_prefix?: string;
        /**
         * Whether to return the redirect url without shortening
         */
        long_redirect_url?: boolean;
        access_token: string;
        id_token?: string;
        token_type?: string;
        refresh_token?: (string) | null;
        expires_in?: (number | string | unknown);
        scope?: (string | Array<(string)> | unknown);
        webhook_signature?: string;
        /**
         * for slack user scopes
         */
        authed_user?: {
            access_token?: string;
            scope?: string;
        };
        [key: string]: ((unknown | string | boolean) | null) | undefined;
    };
} | {
    authScheme: 'API_KEY';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        generic_api_key?: string;
        api_key?: string;
        bearer_token?: string;
        basic_encoded?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BASIC_WITH_JWT';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        username: string;
        password: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BASIC';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        username: string;
        password: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BEARER_TOKEN';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        token: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'OAUTH1';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        oauth_token: string;
        oauth_token_secret: string;
        oauth_verifier?: string;
        consumer_key?: string;
        redirectUrl?: string;
        callback_url?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'NO_AUTH';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
});
        /**
         * Key-value pairs of arguments required by the tool (mutually exclusive with text)
         */
        arguments?: {
            [key: string]: unknown;
        };
        /**
         * Natural language description of the task to perform (mutually exclusive with arguments)
         */
        text?: string;
        /**
         * Enable debug tracing for tool execution (useful for debugging)
         */
        allow_tracing?: (boolean) | null;
    };
    /**
     * The tool slug to execute
     */
    toolSlug: string;
};

export type PostToolsExecuteByToolSlugResponse = ({
    /**
     * Tool execution output data that varies based on the specific tool
     */
    data: {
        [key: string]: unknown;
    };
    /**
     * Error message if the tool execution was not successful (null if successful)
     */
    error: (string) | null;
    /**
     * Indicates if the tool execution was successful
     */
    successful: boolean;
    /**
     * Optional session information for tools that return session context
     */
    session_info?: unknown;
    /**
     * Unique identifier for the execution log (useful for debugging and support)
     */
    log_id?: string;
});

export type PostToolsExecuteByToolSlugInputData = {
    requestBody?: {
        /**
         * Natural language description of what you want to accomplish with this tool
         */
        text: string;
        /**
         * Custom description of the tool to help guide the LLM in generating more accurate inputs
         */
        custom_description?: string;
        /**
         * System prompt to control and guide the behavior of the LLM when generating inputs
         */
        system_prompt?: string;
        /**
         * Tool version to use when generating inputs (defaults to "latest" if not specified)
         */
        version?: string;
    };
    /**
     * The tool slug to generate inputs for
     */
    toolSlug: string;
};

export type PostToolsExecuteByToolSlugInputResponse = ({
    /**
     * Key-value pairs of arguments required by the tool to accomplish the described task
     */
    arguments?: {
        [key: string]: unknown;
    };
    /**
     * Error message if the arguments could not be generated (null if successful)
     */
    error?: string;
});

export type PostToolsExecuteProxyData = {
    requestBody?: {
        /**
         * The ID of the connected account to use for authentication (if not provided, will use the default account for the project)
         */
        connected_account_id?: ConnectedAccountNanoId;
        /**
         * The API endpoint to call (absolute URL or path relative to base URL of the connected account)
         */
        endpoint: string;
        /**
         * The HTTP method to use for the request
         */
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD';
        /**
         * The request body (for POST, PUT, and PATCH requests)
         */
        body?: unknown;
        /**
         * Additional HTTP headers or query parameters to include in the request
         */
        parameters?: Array<{
            /**
             * Parameter name
             */
            name: string;
            /**
             * Parameter value
             */
            value: string;
            /**
             * Parameter type (header or query)
             */
            type: 'header' | 'query';
        }>;
        custom_connection_data?: ({
    authScheme: 'OAUTH2';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        /**
         * The oauth2 state prefix for the connection
         */
        state_prefix?: string;
        /**
         * Whether to return the redirect url without shortening
         */
        long_redirect_url?: boolean;
        access_token: string;
        id_token?: string;
        token_type?: string;
        refresh_token?: (string) | null;
        expires_in?: (number | string | unknown);
        scope?: (string | Array<(string)> | unknown);
        webhook_signature?: string;
        /**
         * for slack user scopes
         */
        authed_user?: {
            access_token?: string;
            scope?: string;
        };
        [key: string]: ((unknown | string | boolean) | null) | undefined;
    };
} | {
    authScheme: 'API_KEY';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        generic_api_key?: string;
        api_key?: string;
        bearer_token?: string;
        basic_encoded?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BASIC_WITH_JWT';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        username: string;
        password: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BASIC';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        username: string;
        password: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'BEARER_TOKEN';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        token: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'OAUTH1';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        oauth_token: string;
        oauth_token_secret: string;
        oauth_verifier?: string;
        consumer_key?: string;
        redirectUrl?: string;
        callback_url?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
} | {
    authScheme: 'NO_AUTH';
    toolkitSlug: string;
    val: {
        subdomain?: string;
        'your-domain'?: string;
        region?: string;
        shop?: string;
        account_url?: string;
        COMPANYDOMAIN?: string;
        extension?: string;
        form_api_base_url?: string;
        instanceEndpoint?: string;
        api_url?: string;
        borneo_dashboard_url?: string;
        proxy_username?: string;
        proxy_password?: string;
        domain?: string;
        version?: string;
        dc?: string;
        site_name?: string;
        instanceName?: string;
        account_id?: string;
        your_server?: string;
        server_location?: string;
        base_url?: string;
        [key: string]: ((unknown | string) | null) | undefined;
    };
});
    };
};

export type PostToolsExecuteProxyResponse = ({
    /**
     * The response data returned from the proxied API
     */
    data?: unknown;
    /**
     * The HTTP status code returned from the proxied API
     */
    status: number;
    /**
     * The HTTP headers returned from the proxied API
     */
    headers?: {
        [key: string]: (string);
    };
});

export type GetTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type GetTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type PostTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type PostTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type HeadTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type HeadTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type PostTriggerInstancesBySlugUpsertData = {
    requestBody?: {
        /**
         * DEPRECATED: This parameter will be removed in a future version. Please use connected_account_id instead.
         * @deprecated
         */
        connectedAuthId?: ConnectedAccountNanoId;
        /**
         * Trigger configuration (deprecated)
         */
        triggerConfig?: {
            [key: string]: unknown;
        };
        /**
         * Connected account nanoid
         */
        connected_account_id?: ConnectedAccountNanoId;
        /**
         * Trigger configuration
         */
        trigger_config?: {
            [key: string]: unknown;
        };
    };
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type PostTriggerInstancesBySlugUpsertResponse = ({
    /**
     * ID of the updated trigger
     */
    trigger_id: string;
    deprecated: {
        /**
         * ID of the updated trigger
         */
        uuid: string;
    };
} | {
    [key: string]: unknown;
});

export type GetTriggerInstancesActiveData = {
    /**
     * Array of auth config IDs to filter triggers by
     */
    authConfigIds?: Array<(string)> | null;
    /**
     * Array of connected account IDs to filter triggers by
     */
    connectedAccountIds?: Array<(string)> | null;
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * Array of auth config UUIDs to filter triggers by
     */
    deprecatedAuthConfigUuids?: Array<(string)> | null;
    /**
     * Array of connected account UUIDs to filter triggers by
     */
    deprecatedConnectedAccountUuids?: Array<(string)> | null;
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Page number for pagination. Starts from 1.
     */
    page?: number;
    /**
     * When set to true, includes disabled triggers in the response.
     */
    showDisabled?: (boolean) | null;
    /**
     * Array of trigger IDs to filter triggers by
     */
    triggerIds?: Array<(string)> | null;
    /**
     * Array of trigger names to filter triggers by
     */
    triggerNames?: Array<(string)> | null;
};

export type GetTriggerInstancesActiveResponse = ({
    items: Array<{
        /**
         * Unique identifier of the trigger instance
         */
        uuid?: string;
        /**
         * Nano ID of the trigger instance
         */
        id: TriggerInstanceNanoId;
        /**
         * ID of the connected account this trigger is associated with
         */
        connected_account_id: string;
        /**
         * Name of the trigger
         */
        trigger_name: string;
        /**
         * UUID of the connected account this trigger is associated with
         */
        connected_account_uuid: string;
        /**
         * ID of the user this trigger is associated with
         */
        user_id: string;
        /**
         * Additional data associated with the trigger instance
         */
        trigger_data?: string;
        /**
         * Configuration for the trigger
         */
        trigger_config: {
            [key: string]: unknown;
        };
        /**
         * State of the trigger instance
         */
        state: {
            [key: string]: unknown;
        };
        /**
         * ISO 8601 timestamp when the trigger instance was updated
         */
        updated_at: string;
        /**
         * ISO 8601 timestamp when the trigger instance was disabled, if applicable
         */
        disabled_at: (string) | null;
        /**
         * ID of the user who disabled the trigger instance, if applicable
         */
        disabledAt: (string) | null;
        /**
         * DEPRECATED: This parameter will be removed in a future version. Please use connected_account_id instead.
         * @deprecated
         */
        connectedAccountId: string;
        /**
         * DEPRECATED: This parameter will be removed in a future version. Please use trigger_name instead.
         * @deprecated
         */
        triggerName: string;
        /**
         * DEPRECATED: This parameter will be removed in a future version. Please use updated_at instead.
         * @deprecated
         */
        updatedAt: string;
        /**
         * DEPRECATED: This parameter will be removed in a future version. Please use trigger_config instead.
         * @deprecated
         */
        triggerConfig: {
            [key: string]: unknown;
        };
        /**
         * Deprecated fields for the trigger instance
         */
        deprecated?: {
            /**
             * Deprecated created_at for the trigger instance
             */
            createdAt: string;
        };
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type DeleteTriggerInstancesManageByTriggerIdData = {
    /**
     * The ID of the trigger instance to delete
     */
    triggerId: TriggerInstanceNanoId;
};

export type DeleteTriggerInstancesManageByTriggerIdResponse = ({
    /**
     * The ID of the deleted trigger instance
     */
    trigger_id: TriggerInstanceNanoId;
});

export type PatchTriggerInstancesManageByTriggerIdData = {
    requestBody?: {
        status: 'enable' | 'disable';
    };
    /**
     * The ID of the trigger instance to update
     */
    triggerId: TriggerInstanceNanoId;
};

export type PatchTriggerInstancesManageByTriggerIdResponse = ({
    /**
     * Status of the operation
     */
    status: 'success';
});

export type GetTriggersTypesListEnumResponse = (string);

export type GetTriggersTypesBySlugData = {
    /**
     * The unique slug identifier for the trigger type
     */
    slug: string;
};

export type GetTriggersTypesBySlugResponse = ({
    /**
     * Unique identifier for the trigger type
     */
    slug: string;
    /**
     * Human-readable name of the trigger
     */
    name: string;
    /**
     * Detailed description of what the trigger does
     */
    description: string;
    /**
     * Step-by-step instructions on how to set up and use this trigger
     */
    instructions: string;
    /**
     * The trigger mechanism - either webhook (event-based) or poll (scheduled check)
     */
    type: 'webhook' | 'poll';
    /**
     * Information about the toolkit that provides this trigger
     */
    toolkit: {
        /**
         * Deprecated: Use slug instead
         * @deprecated
         */
        uuid: string;
        /**
         * Unique identifier for the parent toolkit
         */
        slug: string;
        /**
         * Deprecated: Use slug instead
         */
        name: string;
        /**
         * Logo of the toolkit
         */
        logo: string;
    };
    /**
     * Configuration schema required to set up this trigger
     */
    config: {
        [key: string]: unknown;
    };
    /**
     * Schema of the data payload this trigger will deliver when it fires
     */
    payload: {
        [key: string]: unknown;
    };
});

export type GetTriggersTypesData = {
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Array of toolkit slugs to filter triggers by
     */
    toolkitSlugs?: Array<(string)> | null;
};

export type GetTriggersTypesResponse = ({
    items: Array<{
        /**
         * Unique identifier for the trigger type
         */
        slug: string;
        /**
         * Human-readable name of the trigger
         */
        name: string;
        /**
         * Detailed description of what the trigger does
         */
        description: string;
        /**
         * Step-by-step instructions on how to set up and use this trigger
         */
        instructions: string;
        /**
         * The trigger mechanism - either webhook (event-based) or poll (scheduled check)
         */
        type: 'webhook' | 'poll';
        /**
         * Information about the toolkit that provides this trigger
         */
        toolkit: {
            /**
             * Deprecated: Use slug instead
             * @deprecated
             */
            uuid: string;
            /**
             * Unique identifier for the parent toolkit
             */
            slug: string;
            /**
             * Deprecated: Use slug instead
             */
            name: string;
            /**
             * Logo of the toolkit
             */
            logo: string;
        };
        /**
         * Configuration schema required to set up this trigger
         */
        config: {
            [key: string]: unknown;
        };
        /**
         * Schema of the data payload this trigger will deliver when it fires
         */
        payload: {
            [key: string]: unknown;
        };
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type GetOrgProjectTriggerResponse = ({
    /**
     * Unique identifier for the project
     */
    id: ProjectNanoId;
    /**
     * Identifier of the organization that owns this project
     */
    org_id: OrgNanoId;
    /**
     * Name of the project
     */
    name: string;
    /**
     * Email address associated with the project
     */
    email: string;
    /**
     * ISO timestamp when the project was created
     */
    created_at: string;
    /**
     * ISO timestamp when the project was last updated
     */
    updated_at: string;
    /**
     * URL where webhook events will be sent (can be null)
     */
    webhook_url: (string) | null;
    /**
     * URL where event webhook notifications will be sent (can be null)
     */
    event_webhook_url: (string) | null;
    /**
     * Secret key used to sign webhook payloads for verification
     */
    webhook_secret: (string) | null;
    /**
     * Whether triggers are enabled for this project
     */
    triggers_enabled?: boolean;
    /**
     * ISO timestamp when the project last subscribed to updates
     */
    last_subscribed_at?: (Date) | null;
    /**
     * Indicates if the webhook configuration is using the new format
     */
    is_new_webhook?: boolean;
    /**
     * Whether this project has been soft-deleted
     */
    deleted: boolean;
});

export type PatchOrgProjectTriggerData = {
    /**
     * Boolean flag indicating whether triggers should be enabled (true) or disabled (false) for the project
     */
    enabled?: (boolean) | null;
};

export type PatchOrgProjectTriggerResponse = ({
    /**
     * Unique identifier for the project
     */
    id: ProjectNanoId;
    /**
     * Identifier of the organization that owns this project
     */
    org_id: OrgNanoId;
    /**
     * Name of the project
     */
    name: string;
    /**
     * Email address associated with the project
     */
    email: string;
    /**
     * ISO timestamp when the project was created
     */
    created_at: string;
    /**
     * ISO timestamp when the project was last updated
     */
    updated_at: string;
    /**
     * URL where webhook events will be sent (can be null)
     */
    webhook_url: (string) | null;
    /**
     * URL where event webhook notifications will be sent (can be null)
     */
    event_webhook_url: (string) | null;
    /**
     * Secret key used to sign webhook payloads for verification
     */
    webhook_secret: (string) | null;
    /**
     * Whether triggers are enabled for this project
     */
    triggers_enabled?: boolean;
    /**
     * ISO timestamp when the project last subscribed to updates
     */
    last_subscribed_at?: (Date) | null;
    /**
     * Indicates if the webhook configuration is using the new format
     */
    is_new_webhook?: boolean;
    /**
     * Whether this project has been soft-deleted
     */
    deleted: boolean;
});

export type PostPaymentsSessionData = {
    requestBody?: {
        /**
         * Subscription plan to purchase
         */
        plan: 'HOBBY' | 'STARTER' | 'GROWTH';
        /**
         * Whether to apply discount coupon
         */
        applyDiscount?: (boolean) | null;
    };
};

export type PostPaymentsSessionResponse = ({
    /**
     * URL to the payment page
     */
    url: string;
    /**
     * ID of the created payment session
     */
    sessionId: string;
});

export type PostPaymentsManageSubscriptionData = {
    requestBody?: {
        [key: string]: unknown;
    };
};

export type PostPaymentsManageSubscriptionResponse = ({
    /**
     * URL to the Stripe billing portal
     */
    url: string;
    /**
     * ID of the created billing portal session
     */
    sessionId: string;
});

export type GetAdminCreatePaymentLinkData = {
    /**
     * Payment amount in cents (smallest currency unit)
     */
    amount: number;
    /**
     * Description of the payment that will appear on the invoice and Stripe dashboard
     */
    description?: string;
    /**
     * Customer email address for the payment and receipt
     */
    email: string;
};

export type GetAdminCreatePaymentLinkResponse = ({
    /**
     * Stripe-hosted checkout page URL that the customer should be redirected to
     */
    url: string;
    /**
     * Unique identifier for the checkout session in Stripe. Can be used for status tracking.
     */
    sessionId: string;
});

export type GetMcpValidateByUuidData = {
    /**
     * UUID of the MCP server to validate
     */
    uuid: string;
    /**
     * Admin token
     */
    xComposioAdminToken: string;
};

export type GetMcpValidateByUuidResponse = ({
    /**
     * Unique identifier of the validated MCP server
     */
    id: string;
    /**
     * Human-readable name of the MCP server
     */
    name: string;
    /**
     * URL endpoint for connecting to this MCP server
     */
    url: string;
    /**
     * Client information for the MCP server
     */
    client: {
        /**
         * Project identifier that owns this MCP server
         */
        id: string;
        /**
         * Organization identifier that owns the project
         */
        orgId: string;
    };
    /**
     * User authentication data for the MCP server
     */
    userData: {
        /**
         * User identifier for API access
         */
        id: string;
        /**
         * Email address associated with the API key user
         */
        email: string;
        /**
         * API key for authenticating requests to the Composio API
         */
        apiKey: string;
    };
    /**
     * List of application identifiers this server is configured for
     */
    toolkits?: Array<(string)>;
    /**
     * List of action identifiers enabled for this server
     */
    allowed_tools?: Array<(string)> | null;
    /**
     * Flag indicating if this server uses custom authentication headers
     */
    customAuthHeaders?: boolean;
    /**
     * Flag indicating if this server is managed by Composio and not by the user
     */
    managed_auth_via_composio?: boolean;
});

export type GetMcpServersData = {
    /**
     * Comma-separated list of auth config IDs to filter servers by
     */
    authConfigIds?: string;
    /**
     * Number of items per page (default: 10)
     */
    limit?: (number) | null;
    /**
     * Filter MCP servers by name (case-insensitive partial match)
     */
    name?: string;
    /**
     * Page number for pagination (1-based)
     */
    pageNo?: (number) | null;
    /**
     * Comma-separated list of toolkit slugs to filter servers by
     */
    toolkits?: string;
};

export type GetMcpServersResponse = ({
    /**
     * Array of MCP server configurations
     */
    items: Array<{
        /**
         * UUID of the MCP server instance
         */
        id: string;
        /**
         * User-defined descriptive name for this MCP server
         */
        name: string;
        /**
         * ID references to the auth configurations used by this server
         */
        auth_config_ids: Array<(string)>;
        /**
         * Array of tool slugs that this MCP server is allowed to use
         */
        allowed_tools: Array<(string)>;
        /**
         * URL endpoint for establishing SSE connection to this MCP server
         */
        mcp_url: string;
        /**
         * Array of toolkit slugs that this MCP server is allowed to use
         */
        toolkits: Array<(string)>;
        /**
         * Set of command line instructions for connecting various clients to this MCP server
         */
        commands: {
            /**
             * Command line instruction for Cursor client setup
             */
            cursor: string;
            /**
             * Command line instruction for Claude client setup
             */
            claude: string;
            /**
             * Command line instruction for Windsurf client setup
             */
            windsurf: string;
        };
        /**
         * Date and time when this server configuration was last modified
         */
        updated_at: string;
        /**
         * Date and time when this server was initially created
         */
        created_at: string;
        /**
         * Whether the MCP server is managed by Composio
         */
        managed_auth_via_composio: boolean;
    }>;
    /**
     * Total number of pages in the paginated response
     */
    total_pages: number;
    /**
     * Current page number being returned
     */
    current_page: number;
});

export type PostMcpServersData = {
    requestBody?: {
        /**
         * Human-readable name to identify this MCP server instance (4-30 characters, alphanumeric, spaces, and hyphens only)
         */
        name: string;
        /**
         * ID references to existing authentication configurations
         */
        auth_config_ids: Array<(string)>;
        /**
         * List of tool slugs that should be allowed for this server. If not provided, all available tools for the authentication configuration will be enabled.
         */
        allowed_tools?: Array<(string)>;
        /**
         * Whether the MCP server is managed by Composio
         */
        managed_auth_via_composio?: boolean;
    };
};

export type PostMcpServersResponse = ({
    /**
     * UUID of the MCP server instance
     */
    id: string;
    /**
     * User-defined descriptive name for this MCP server
     */
    name: string;
    /**
     * ID references to the auth configurations used by this server
     */
    auth_config_ids: Array<(string)>;
    /**
     * Array of tool slugs that this MCP server is allowed to use
     */
    allowed_tools: Array<(string)>;
    /**
     * URL endpoint for establishing SSE connection to this MCP server
     */
    mcp_url: string;
    /**
     * Array of toolkit slugs that this MCP server is allowed to use
     */
    toolkits: Array<(string)>;
    /**
     * Set of command line instructions for connecting various clients to this MCP server
     */
    commands: {
        /**
         * Command line instruction for Cursor client setup
         */
        cursor: string;
        /**
         * Command line instruction for Claude client setup
         */
        claude: string;
        /**
         * Command line instruction for Windsurf client setup
         */
        windsurf: string;
    };
    /**
     * Date and time when this server configuration was last modified
     */
    updated_at: string;
    /**
     * Date and time when this server was initially created
     */
    created_at: string;
    /**
     * Whether the MCP server is managed by Composio
     */
    managed_auth_via_composio: boolean;
});

export type PostMcpServersCustomData = {
    requestBody?: {
        /**
         * Human-readable name to identify this custom MCP server (4-30 characters, alphanumeric, spaces, and hyphens only)
         */
        name: string;
        /**
         * ID references to existing authentication configurations
         */
        auth_config_ids?: Array<(string)>;
        /**
         * List of application/toolkit identifiers to enable for this server
         */
        toolkits: Array<(string)>;
        /**
         * Additional custom tool identifiers to enable that aren't part of standard toolkits
         */
        custom_tools?: Array<(string)>;
        /**
         * Whether to manage authentication via Composio
         */
        managed_auth_via_composio?: boolean;
    };
};

export type PostMcpServersCustomResponse = ({
    /**
     * Unique identifier for the newly created custom MCP server
     */
    id: string;
    /**
     * Human-readable name of the custom MCP server
     */
    name: string;
    /**
     * ID references to the auth configurations used by this server
     */
    auth_config_ids: Array<(string)>;
    /**
     * List of tool identifiers that are enabled for this server
     */
    allowed_tools: Array<(string)>;
    /**
     * URL endpoint for establishing Server-Sent Events (SSE) connection to this MCP server
     */
    mcp_url: string;
    /**
     * Set of command line instructions for connecting various clients to this MCP server
     */
    commands: {
        /**
         * Command line instruction for Cursor client setup
         */
        cursor: string;
        /**
         * Command line instruction for Claude client setup
         */
        claude: string;
        /**
         * Command line instruction for Windsurf client setup
         */
        windsurf: string;
    };
});

export type PostMcpServersGenerateData = {
    requestBody?: {
        /**
         * Unique identifier of the MCP server to generate URL for
         */
        mcp_server_id: string;
        /**
         * Flag indicating if Composio manages authentication
         */
        managed_auth_by_composio?: boolean;
        /**
         * List of user identifiers for whom the URL is generated
         */
        user_ids?: Array<(string)>;
        /**
         * List of connected account identifiers
         */
        connected_account_ids?: Array<(string)>;
    };
};

export type PostMcpServersGenerateResponse = ({
    /**
     * Base MCP URL without any query parameters
     */
    mcp_url: string;
    /**
     * List of URLs generated for each connected account ID
     */
    connected_account_urls: Array<(string)>;
    /**
     * List of URLs generated for each user ID
     */
    user_ids_url: Array<(string)>;
});

export type GetMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
};

export type GetMcpByIdResponse = ({
    /**
     * UUID of the MCP server instance
     */
    id: string;
    /**
     * User-defined descriptive name for this MCP server
     */
    name: string;
    /**
     * ID references to the auth configurations used by this server
     */
    auth_config_ids: Array<(string)>;
    /**
     * Array of tool slugs that this MCP server is allowed to use
     */
    allowed_tools: Array<(string)>;
    /**
     * URL endpoint for establishing SSE connection to this MCP server
     */
    mcp_url: string;
    /**
     * Array of toolkit slugs that this MCP server is allowed to use
     */
    toolkits: Array<(string)>;
    /**
     * Set of command line instructions for connecting various clients to this MCP server
     */
    commands: {
        /**
         * Command line instruction for Cursor client setup
         */
        cursor: string;
        /**
         * Command line instruction for Claude client setup
         */
        claude: string;
        /**
         * Command line instruction for Windsurf client setup
         */
        windsurf: string;
    };
    /**
     * Date and time when this server configuration was last modified
     */
    updated_at: string;
    /**
     * Date and time when this server was initially created
     */
    created_at: string;
    /**
     * Whether the MCP server is managed by Composio
     */
    managed_auth_via_composio: boolean;
    /**
     * Whether the MCP server is deleted
     */
    deleted: boolean;
});

export type PatchMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
    requestBody?: {
        /**
         * Human-readable name to identify this MCP server instance (4-30 characters, alphanumeric, spaces, and hyphens only)
         */
        name?: string;
        /**
         * List of toolkit slugs this server should be configured to work with
         */
        toolkits?: Array<(string)>;
        /**
         * List of action identifiers that should be enabled for this server
         */
        allowed_tools?: Array<(string)>;
        /**
         * Whether the MCP server is managed by Composio
         */
        managed_auth_via_composio?: boolean;
    };
};

export type PatchMcpByIdResponse = ({
    /**
     * UUID of the MCP server instance
     */
    id: string;
    /**
     * User-defined descriptive name for this MCP server
     */
    name: string;
    /**
     * ID references to the auth configurations used by this server
     */
    auth_config_ids: Array<(string)>;
    /**
     * Array of tool slugs that this MCP server is allowed to use
     */
    allowed_tools: Array<(string)>;
    /**
     * URL endpoint for establishing SSE connection to this MCP server
     */
    mcp_url: string;
    /**
     * Array of toolkit slugs that this MCP server is allowed to use
     */
    toolkits: Array<(string)>;
    /**
     * Set of command line instructions for connecting various clients to this MCP server
     */
    commands: {
        /**
         * Command line instruction for Cursor client setup
         */
        cursor: string;
        /**
         * Command line instruction for Claude client setup
         */
        claude: string;
        /**
         * Command line instruction for Windsurf client setup
         */
        windsurf: string;
    };
    /**
     * Date and time when this server configuration was last modified
     */
    updated_at: string;
    /**
     * Date and time when this server was initially created
     */
    created_at: string;
    /**
     * Whether the MCP server is managed by Composio
     */
    managed_auth_via_composio: boolean;
    /**
     * Whether the MCP server is deleted
     */
    deleted: boolean;
});

export type DeleteMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
};

export type DeleteMcpByIdResponse = ({
    /**
     * Indicates whether the MCP server was successfully deleted
     */
    success: boolean;
});

export type GetMcpAppByAppKeyData = {
    /**
     * The key of the app to find MCP servers for
     */
    appKey: string;
    /**
     * Comma-separated list of auth config IDs to filter servers by
     */
    authConfigIds?: string;
    /**
     * Number of items per page (default: 10)
     */
    limit?: (number) | null;
    /**
     * Filter MCP servers by name (case-insensitive partial match)
     */
    name?: string;
    /**
     * Page number for pagination (1-based)
     */
    pageNo?: (number) | null;
    /**
     * Comma-separated list of toolkit slugs to filter servers by
     */
    toolkits?: string;
};

export type GetMcpAppByAppKeyResponse = ({
    /**
     * Array of MCP server configurations
     */
    items: Array<{
        /**
         * UUID of the MCP server instance
         */
        id: string;
        /**
         * User-defined descriptive name for this MCP server
         */
        name: string;
        /**
         * ID references to the auth configurations used by this server
         */
        auth_config_ids: Array<(string)>;
        /**
         * Array of tool slugs that this MCP server is allowed to use
         */
        allowed_tools: Array<(string)>;
        /**
         * URL endpoint for establishing SSE connection to this MCP server
         */
        mcp_url: string;
        /**
         * Array of toolkit slugs that this MCP server is allowed to use
         */
        toolkits: Array<(string)>;
        /**
         * Set of command line instructions for connecting various clients to this MCP server
         */
        commands: {
            /**
             * Command line instruction for Cursor client setup
             */
            cursor: string;
            /**
             * Command line instruction for Claude client setup
             */
            claude: string;
            /**
             * Command line instruction for Windsurf client setup
             */
            windsurf: string;
        };
        /**
         * Date and time when this server configuration was last modified
         */
        updated_at: string;
        /**
         * Date and time when this server was initially created
         */
        created_at: string;
        /**
         * Whether the MCP server is managed by Composio
         */
        managed_auth_via_composio: boolean;
    }>;
    /**
     * Total number of pages in the paginated response
     */
    total_pages: number;
    /**
     * Current page number being returned
     */
    current_page: number;
});

export type GetFilesListData = {
    /**
     * Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
     */
    cursor?: string;
    /**
     * Number of items per page
     */
    limit?: (number) | null;
    /**
     * Filter files by app slug. Example: "file-converter"
     */
    toolkitSlug?: string;
    /**
     * Filter files by action slug. Example: "convert-to-pdf"
     */
    toolSlug?: string;
};

export type GetFilesListResponse = ({
    items: Array<{
        /**
         * Slug of the app where this file belongs to. Example: "file-converter"
         */
        toolkit_slug: string;
        /**
         * Slug of the action where this file belongs to. Example: "convert-to-pdf"
         */
        tool_slug: string;
        /**
         * Name of the original file. Example: "document.docx"
         */
        filename: string;
        /**
         * Mime type of the original file. Example: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
         */
        mimetype: string;
        /**
         * MD5 hash of the file for integrity verification. Example: "d41d8cd98f00b204e9800998ecf8427e"
         */
        md5: string;
    }>;
    next_cursor?: (string) | null;
    total_pages: number;
    current_page: number;
    total_items: number;
});

export type PostFilesUploadRequestData = {
    requestBody?: {
        /**
         * Slug of the app where this file belongs to. Example: "image-processing"
         */
        toolkit_slug: string;
        /**
         * Slug of the action where this file belongs to. Example: "resize-image"
         */
        tool_slug: string;
        /**
         * Name of the original file. Example: "photo.jpg"
         */
        filename: string;
        /**
         * Mime type of the original file. Example: "image/jpeg"
         */
        mimetype: string;
        /**
         * MD5 hash of the file for deduplication and integrity verification. Example: "d41d8cd98f00b204e9800998ecf8427e"
         */
        md5: string;
    };
};

export type PostFilesUploadRequestResponse = (({
    /**
     * ID of the request file. Example: "f1e2d3c4b5a6"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/files/photo-1234.jpg"
     */
    key: string;
    /**
     * URL of the existing request file. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg"
     */
    existing_url: string;
    /**
     * [DEPRECATED] Use existing_url instead. URL of the existing request file. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg"
     */
    existingUrl: string;
    /**
     * Indicates the file already exists and does not need to be uploaded again
     */
    type: 'existing';
} | {
    /**
     * ID of the request file. Example: "f1e2d3c4b5a6"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/files/photo-1234.jpg"
     */
    key: string;
    /**
     * Presigned URL for upload. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg?X-Amz-Algorithm=..."
     */
    new_presigned_url: string;
    /**
     * [DEPRECATED] Use new_presigned_url instead. Presigned URL for upload. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg?X-Amz-Algorithm=..."
     */
    newPresignedUrl: string;
    /**
     * Indicates this is a new file that needs to be uploaded
     */
    type: 'new';
} | {
    /**
     * ID of the request file. Example: "f1e2d3c4b5a6"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/files/photo-1234.jpg"
     */
    key: string;
    /**
     * Presigned URL for upload. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg?X-Amz-Algorithm=..."
     */
    update_presigned_url: string;
    /**
     * [DEPRECATED] Use update_presigned_url instead. Presigned URL for upload. Example: "https://storage.example.com/projects/123/files/photo-1234.jpg?X-Amz-Algorithm=..."
     */
    updatePresignedUrl: string;
    /**
     * Indicates this file exists but needs to be updated with a new version
     */
    type: 'update';
}));

export type PostFilesUploadResponseData = {
    /**
     * Required admin token for authorization to upload response files. This token must match the APOLLO_ADMIN_TOKEN environment variable.
     */
    adminToken: string;
    requestBody?: {
        /**
         * Slug of the app where this response file belongs to. Example: "pdf-analyzer"
         */
        toolkit_slug: string;
        /**
         * Slug of the action where this response file belongs to. Example: "extract-text"
         */
        tool_slug: string;
        /**
         * Name of the original response file. Example: "extracted_text.txt"
         */
        filename: string;
        /**
         * Mime type of the original response file. Example: "text/plain"
         */
        mimetype: string;
        /**
         * MD5 hash of the response file for deduplication and integrity verification. Example: "a1b2c3d4e5f6g7h8i9j0"
         */
        md5: string;
    };
};

export type PostFilesUploadResponseResponse = (({
    /**
     * ID of the response file. Example: "r1e2s3p4o5n6s7e8"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/responses/text-1234.txt"
     */
    key: string;
    /**
     * URL of the existing response file. Example: "https://storage.example.com/projects/123/responses/text-1234.txt"
     */
    existing_url: string;
    /**
     * Indicates the response file already exists and does not need to be uploaded again
     */
    type: 'existing';
    /**
     * [DEPRECATED] Use existing_url instead. URL of the existing response file. Example: "https://storage.example.com/projects/123/responses/text-1234.txt"
     */
    existingUrl: string;
} | {
    /**
     * ID of the response file. Example: "r1e2s3p4o5n6s7e8"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/responses/text-1234.txt"
     */
    key: string;
    /**
     * Presigned URL for response file upload. Example: "https://storage.example.com/projects/123/responses/text-1234.txt?X-Amz-Algorithm=..."
     */
    new_presigned_url: string;
    /**
     * [DEPRECATED] Use new_presigned_url instead. Presigned URL for response file upload. Example: "https://storage.example.com/projects/123/responses/text-1234.txt?X-Amz-Algorithm=..."
     */
    newPresignedUrl: string;
    /**
     * Indicates this is a new response file that needs to be uploaded
     */
    type: 'new';
} | {
    /**
     * ID of the response file. Example: "r1e2s3p4o5n6s7e8"
     */
    id: string;
    /**
     * S3 upload location. Example: "projects/123/responses/text-1234.txt"
     */
    key: string;
    /**
     * Presigned URL for response file upload. Example: "https://storage.example.com/projects/123/responses/text-1234.txt?X-Amz-Algorithm=..."
     */
    update_presigned_url: string;
    /**
     * [DEPRECATED] Use update_presigned_url instead. Presigned URL for response file upload. Example: "https://storage.example.com/projects/123/responses/text-1234.txt?X-Amz-Algorithm=..."
     */
    updatePresignedUrl: string;
    /**
     * Indicates this response file exists but needs to be updated with a new version
     */
    type: 'update';
}));

export type GetMigrationGetNanoidData = {
    /**
     * The type of resource that the UUID belongs to
     */
    type: 'CONNECTED_ACCOUNT' | 'AUTH_CONFIG' | 'TRIGGER_INSTANCE';
    /**
     * The legacy UUID that needs to be converted to a NanoId
     */
    uuid: string;
    xApiKey: string;
};

export type GetMigrationGetNanoidResponse = ({
    /**
     * The NanoId corresponding to the provided UUID. This is the new identifier that should be used in place of the legacy UUID.
     */
    nanoid: string;
});

export type PostOrgProjectNewResponseTransformer = (data: any) => Promise<PostOrgProjectNewResponse>;

export const PostOrgProjectNewResponseTransformer: PostOrgProjectNewResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type GetOrgProjectByProjectIdResponseTransformer = (data: any) => Promise<GetOrgProjectByProjectIdResponse>;

export const GetOrgProjectByProjectIdResponseTransformer: GetOrgProjectByProjectIdResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type PostOrgProjectByProjectIdApiKeysCreateResponseTransformer = (data: any) => Promise<PostOrgProjectByProjectIdApiKeysCreateResponse>;

export const PostOrgProjectByProjectIdApiKeysCreateResponseTransformer: PostOrgProjectByProjectIdApiKeysCreateResponseTransformer = async (data) => {
    if (data?.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data?.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data?.last_used_at) {
        data.last_used_at = new Date(data.last_used_at);
    }
    return data;
};

export type GetOrgProjectTriggerResponseTransformer = (data: any) => Promise<GetOrgProjectTriggerResponse>;

export const GetOrgProjectTriggerResponseTransformer: GetOrgProjectTriggerResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type PatchOrgProjectTriggerResponseTransformer = (data: any) => Promise<PatchOrgProjectTriggerResponse>;

export const PatchOrgProjectTriggerResponseTransformer: PatchOrgProjectTriggerResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};